import { useQuery } from '@tanstack/react-query';
import cacheQueryKeys from 'resources/ReactQuery/queryCacheKeys';
import { captureException } from 'utils/exception';

import { Codeowners } from 'components/Common/Error/Codeowners';
import { formatServicesData } from 'components/OnlineBookingSettings/hooks/useServices';

import { fetchServices } from '../api/api';

export const useServices = ({ orgUuid }: { orgUuid: string }) => {
  return useQuery([cacheQueryKeys.AvailablePublicServices], () => fetchServices(orgUuid), {
    select: ({ data, ...rest }) => {
      let newData = null;
      try {
        newData = formatServicesData(data);
      } catch (error) {
        captureException(error, Codeowners.CUSTOMER_INTAKE);
      }

      return {
        ...rest,
        data: newData,
      };
    },
  });
};
